import { ReactNode } from 'react';

const AUTH_PAGE_SHAPES = [
  {
    zIndex: 0,
    className:
      'left-0 top-1/2 aspect-square h-[180vh] translate-x-[-50%] translate-y-[-50%] rounded-full bg-secondary-light-blue-gray outline outline-[100px] outline-secondary-light-gray'
  },
  {
    zIndex: 9,
    className:
      'left-0 top-0 aspect-square h-[110vh] translate-x-[-50%] translate-y-[-50%] rounded-full bg-gradient-radial from-secondary-steel-blue from-10% to-secondary-light-blue-gray to-70%'
  },
  {
    zIndex: 2,
    className:
      'left-0 top-[100%] aspect-square h-[70vh] translate-x-[-50%] translate-y-[-50%] rounded-full bg-gradient-radial from-secondary-pale-blue-gray from-40% to-secondary-light-blue-gray to-60%'
  },
  {
    zIndex: 9,
    className:
      'bottom-0 right-0 aspect-square h-[110vh] translate-x-[50%] translate-y-[50%] rounded-full bg-gradient-radial from-secondary-light-blue-gray from-40% to-primary-gray to-60%'
  },
  {
    zIndex: 0,
    className:
      'right-0 top-0 aspect-square h-[75vh] translate-x-[50%] translate-y-[-50%] rounded-full bg-gradient-radial from-primary-white from-30% to-primary-gray to-60%'
  }
];

const BackgroundShape = ({ zIndex, className }: { zIndex: number; className: string }) => (
  <div className={`absolute ${className}`} style={{ zIndex }} />
);

export const AuthPageLayout = ({ children }: { children: ReactNode }) => (
  <div className='relative flex h-screen w-full items-center justify-center overflow-hidden bg-primary-gray'>
    {AUTH_PAGE_SHAPES.map((shape, index) => (
      <BackgroundShape key={index} zIndex={shape.zIndex} className={shape.className} />
    ))}

    <div className='z-10 flex w-[90%] max-w-xl items-center justify-center rounded-3xl bg-primary-white p-6 sm:p-8 lg:p-10'>
      {children}
    </div>
  </div>
);
